'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var accordionHeader = require('./accordion-header.js');
var accordionPanel = require('./accordion-panel.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * A single accordion with a header and panel.
 * @param {AccordionProps} props AccordionProps
 */ const Accordion = (props)=>{
    const { accordion , animation , disabled , focusIndex , id , index , loading , onChange , onKeyUp , open , unmountOnExit  } = props;
    const accordionButtonId = `${id}-button-${index}`;
    const accordionPanelId = `${id}-panel-${index}`;
    return /*#__PURE__*/ React__default.default.createElement(React__default.default.Fragment, null, /*#__PURE__*/ React__default.default.createElement(accordionHeader.AccordionHeader, {
        accordionPanelId: accordionPanelId,
        buttonIcon: accordion.buttonIcon,
        buttonIconPosition: accordion.buttonIconPosition,
        buttonProps: accordion.buttonProps,
        disabled: disabled,
        focusIndex: focusIndex,
        headerContent: accordion.headerContent,
        headerContentPosition: accordion.headerContentPosition,
        headingProps: accordion.headingProps,
        id: accordionButtonId,
        index: index,
        onChange: onChange,
        onKeyUp: onKeyUp,
        open: open,
        showText: accordion.showText
    }, accordion.button), /*#__PURE__*/ React__default.default.createElement(accordionPanel.AccordionPanel, {
        accordionButtonId: accordionButtonId,
        animation: animation,
        id: accordionPanelId,
        loading: loading,
        open: open,
        panelProps: accordion.panelProps,
        unmountOnExit: unmountOnExit
    }, accordion.panel));
};

exports.Accordion = Accordion;
//# sourceMappingURL=accordion-main.js.map
